// Icons describe the registered event/target, never the wording of its title.
const events = {
  PLAN_CONFIRMATION_REQUIRED: ['clipboard-list', 'purple'],
  QUESTION_REPLY_REQUIRED: ['message-circle-question', 'blue'],
  PERMISSION_REPLY_REQUIRED: ['shield-check', 'amber'],
  RESEARCH_DELIVERY_FINISHED: ['file-check-2', 'purple'],
  ANALYSIS_ACTION_REQUIRED: ['triangle-alert', 'amber'],
  ANALYSIS_FINISHED: ['chart-no-axes-combined', 'blue'],
  REPORT_GENERATION_FINISHED: ['file-text', 'purple'],
  CLINICAL_CHECKPOINT_REQUIRED: ['clipboard-list', 'purple'],
  CLINICAL_ACTION_REQUIRED: ['triangle-alert', 'amber'],
  CLINICAL_FINISHED: ['file-text', 'purple'],
  TCM_MICROBIOTA_FINISHED: ['chart-no-axes-combined', 'blue'],
  NOTEBOOK_ACTION_REQUIRED: ['notebook-tabs', 'blue'],
  NOTEBOOK_FINISHED: ['notebook-tabs', 'blue'],
  SCIENTIFIC_REVIEW_FINISHED: ['shield-check', 'purple'],
  COMMUNITY_REVIEW_REQUIRED: ['files', 'blue'],
  COMMUNITY_REVIEW_RESULT: ['files', 'blue'],
  RESEARCH_SHARE_CHANGED: ['files', 'blue'],
  RESEARCH_RECOMMENDATION_READY: ['lightbulb', 'blue'],
  RELEASE_PUBLISHED: ['megaphone', 'purple'],
  SERVICE_ANNOUNCEMENT_PUBLISHED: ['megaphone', 'purple'],
  DATASET_ANNOUNCEMENT_PUBLISHED: ['database', 'blue'],
  GIFT_CLAIM_REQUIRED: ['gift', 'purple'],
  SUBSCRIPTION_ENTITLEMENT_CHANGED: ['crown', 'purple'],
  SUBSCRIPTION_EXPIRY_CHANGED: ['crown', 'purple'],
  GIFT_SHARING_REMINDER: ['gift', 'purple'],
  BALANCE_ACTION_REQUIRED: ['circle-dollar-sign', 'amber'],
  DATASET_BILLING_ACTION_REQUIRED: ['database', 'amber'],
  RECHARGE_STATUS_CHANGED: ['circle-dollar-sign', 'blue'],
  INVOICE_STATUS_CHANGED: ['receipt-text', 'blue'],
  ENTERPRISE_ACCESS_CHANGED: ['users', 'blue'],
  FEEDBACK_STATUS_CHANGED: ['message-square', 'blue'],
}
const targets = {
  RELEASE: ['megaphone', 'purple'], DATASET_ANNOUNCEMENT: ['database', 'blue'],
  ANALYSIS_RUN: ['chart-no-axes-combined', 'blue'], CLINICAL_RUN: ['file-text', 'purple'],
  MICROBIOTA_RUN: ['chart-no-axes-combined', 'blue'], NOTEBOOK: ['notebook-tabs', 'blue'],
  GIFT: ['gift', 'purple'], RESEARCH_SHARE: ['files', 'blue'],
}

export function messagePresentation(message) {
  if (message.eventType === 'ANALYSIS_FINISHED') {
    if (message.content?.outcome === 'COMPLETED') return { icon: 'circle-check', tone: 'blue' }
    if (message.content?.outcome === 'FAILED') return { icon: 'triangle-alert', tone: 'amber' }
  }
  if (message.eventType === 'REPORT_GENERATION_FINISHED' && message.target?.section === 'report-attempt') {
    return { icon: 'triangle-alert', tone: 'amber' }
  }
  const eventIcon = Object.hasOwn(events, message.eventType) ? events[message.eventType] : null
  const targetIcon = Object.hasOwn(targets, message.target?.type) ? targets[message.target.type] : null
  const [icon, tone] = eventIcon || targetIcon
    || (message.category === 'WORK' ? ['bell', 'blue'] : ['megaphone', 'purple'])
  return { icon, tone }
}
